import { fromJS, Map } from 'immutable';

import PageRecord from 'records/page';
import { createSymbols } from 'utils/helpers';
import baseReducer from 'redux/baseReducer';

export const {
    EDIT_PAGE,
    RESET_PAGE,
    TOGGLE_CUSTOMIZE_PAGE,
    UPDATE_PAGE,
    UPDATE_PAGE_FAIL,
    UPDATE_PAGE_SUCCESS,
} = createSymbols([
    'EDIT_PAGE',
    'RESET_PAGE',
    'TOGGLE_CUSTOMIZE_PAGE',
    'UPDATE_PAGE',
    'UPDATE_PAGE_FAIL',
    'UPDATE_PAGE_SUCCESS',
]);

export const initialState = fromJS({
    customizePage: false,
    data: PageRecord(),
    dialogOpen: false,
    errors: {},
    isFetching: false,
    medium: {},
});

const editPage = (state, { field, value }) => state.setIn(['data', ...field], value);
const resetPage = () => initialState;
const toggleCustomizePage = (state) => state.set('customizePage', !state.get('customizePage'));
const updatePageFail = (state, { error }) => state.set('errors', error);
const updatePageSuccess = (state, { payload }) => state.withMutations((prevState) => {
    prevState
        .set('data', PageRecord(payload.data))
        .set('errors', Map());
});

export default baseReducer(initialState, {
    [EDIT_PAGE]: editPage,
    [RESET_PAGE]: resetPage,
    [TOGGLE_CUSTOMIZE_PAGE]: toggleCustomizePage,
    [UPDATE_PAGE_FAIL]: updatePageFail,
    [UPDATE_PAGE_SUCCESS]: updatePageSuccess,
});
